module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "theline"
  }, [(!_vm.isMobile()) ? _c('b', [_vm._v("The Line")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexRow blockRow"
  }, _vm._l((_vm.blocks), function(n, i) {
    return _c('div', {
      key: i,
      staticClass: "block",
      class: {
        quota: n.quota
      },
      style: (("background-color: " + (n.color) + ";}")),
      attrs: {
        "title": n.title
      }
    })
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-520a38b5!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/TheLine.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-520a38b5!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/TheLine.vue
// module chunks = 0